import { css } from '@emotion/react';
import styled from '@emotion/styled';
import ArrowDown from '@engineering/icons/arrow-down';
import ArrowUp from '@engineering/icons/arrow-up';

import { Theme } from '@silvertours/front-shared';

/** @todo: maybe consider moving this into our theme? */
type GridColumnCount = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8;
type GridSize = `g${GridColumnCount}`;

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const cq = (_size: GridSize) => '@container (min-width: 39.375rem) ';

const FeedbackContainer = styled.div<{
  hasSummary?: boolean;
}>`
  display: flex;
  flex-direction: column;
  column-gap: 1rem;

  ${cq('g8')} {
    flex-direction: ${props => (props.hasSummary ? 'row' : 'column')};
    row-gap: 1rem;
  }
`;

const SummaryContainer = styled.div`
  ${cq('g8')} {
    flex: 1;
  }
`;

const AverageRating = styled.div`
  margin-bottom: 1.875rem;

  ${cq('g8')} {
    margin-bottom: 0;
  }
`;

const ColoredText = styled.span`
  color: ${({ theme }) => theme.color.brand};
`;

const LocationName = styled.span`
  display: inline-block;
  margin-bottom: 0.5rem;
`;

const ReviewListContainer = styled.div`
  width: 100%;

  ${cq('g8')} {
    flex: 1;
  }
`;

const ReviewContainer = styled.div<{ largeReview?: boolean }>`
  padding: 0.5rem;
  border: 1px solid ${({ theme }) => theme.color.grey03};
  margin-bottom: ${({ largeReview }) => (largeReview ? '1rem' : '-1px')};
`;

const StyledHeader = styled.div`
  width: 100%;
  display: inline-flex;
  column-gap: 0.625rem;
`;

const ReviewFooter = styled.div`
  width: 100%;
  display: inline-flex;
  justify-content: space-between;
  column-gap: 0.625rem;

  button {
    padding: 0.6rem;
  }
`;

const QuoteContainer = styled.div`
  margin: 0.625rem 0;

  p {
    margin: 0.3125rem 0;
  }
`;

const RatingGroupList = styled.ul`
  margin-top: 0.625rem;
  background-color: ${({ theme }) => theme.color.grey05};
  padding: 0.625rem;

  p {
    font-size: 0.75rem;
    display: flex;
    column-gap: 0.625rem;

    > span {
      width: 35%;
    }
  }
`;

const RatingGroupItemCriterion = styled.span`
  margin-right: 2.1875rem;
`;

const getArrowStyles = (theme: Theme.Theme) => css`
  width: 0.75rem;
  height: 0.75rem;
  fill: ${theme.color.brand};
`;

const ArrowDownIcon = styled(ArrowDown)`
  ${({ theme }) => getArrowStyles(theme)};
`;

const ArrowUpIcon = styled(ArrowUp)`
  ${({ theme }) => getArrowStyles(theme)};
`;

export {
  AverageRating,
  ColoredText,
  FeedbackContainer,
  LocationName,
  ReviewListContainer,
  ReviewContainer,
  ReviewFooter,
  RatingGroupList,
  RatingGroupItemCriterion,
  StyledHeader,
  SummaryContainer,
  QuoteContainer,
  ArrowDownIcon,
  ArrowUpIcon,
};
